/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.expo = window.expo || {};

expo.cacheSelectors = function () {
  expo.cache = {
    // General
    $w: $(window),
    $body: $('body'),
    $tabTrigger: $('.tab-switch__trigger'),
    $tabContent: $('.tab-switch__content'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileNavCloseTrigger: $('#MobileNavCloseTrigger'),
    $mobileNavClose: $('#MobileNavClose'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    //Mobile Search
    $mobileSearchTrigger: $('#MobileSearchTrigger'),
    $mobileSearch: $('#MobileSearch'),
    $mobilePageOverlay: $('#PageOverlay'),

    // Mobile Filter
    $mobileFilterTrigger: $('#MobileFilterTrigger'),
    $mobileFilter: $('#MobileFilter'),
    $mobileFilterCloseTrigger: $('#MobileFilterCloseTrigger'),
    $mobileFilterClose: $('#MobileFilterClose'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Sidebar nav
    $sidebarDropdown: $('.sidebar-sublist'),
    $sidebarSubLists: $('.sidebar-sublist__content'),
    $sidebarViewMore: $('.sidebar-module__viewmore'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown'),
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

expo.init = function () {
  expo.cacheSelectors();
  expo.mobileNav();
  expo.mobileFilter();
  expo.mobileNavClose();
  expo.mobileFilterClose();
  expo.searchNav();
  expo.mobileScrollHandler();
  timber.cacheVariables();
  expo.equalHeights();
  expo.sidebarViewMore();
  expo.sidebarDropdowns();
  expo.sidebarDropdownCheck();

  expo.cartPage();
  expo.toggleMenu();
};

expo.mobileNav = function () {
  expo.cache.$mobileNavTrigger.on('click', function() {
    expo.cache.$mobileNav.slideToggle(220);
    expo.cache.$mobileNavClose.fadeToggle('fast');
    expo.cache.$mobilePageOverlay.hide('fast');
    expo.cache.$mobileSearch.hide('fast');
  });

  expo.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

expo.mobileNavClose = function () {
  expo.cache.$mobileNavCloseTrigger.on('click', function() {
    expo.cache.$mobileNav.slideToggle(220);
    expo.cache.$mobileNavClose.fadeToggle('fast');
    expo.cache.$mobilePageOverlay.hide('fast');
    expo.cache.$mobileSearch.hide('fast');
  });
};

expo.mobileFilter = function () {
  expo.cache.$mobileFilterTrigger.on('click', function() {
    expo.cache.$w.scrollTop(0);
    expo.cache.$mobileFilter.slideToggle(220);
    expo.cache.$mobileFilterClose.fadeToggle('fast');
    $('.filter-menu-container').addClass('absolute mt-[-46px] z-10').slideToggle(220);
    console.log('click', expo.cache.$mobileFilter);
    //$('.main-content .container').addClass('mt-[-18px]');
  });
};

expo.mobileFilterClose = function () {
  expo.cache.$mobileFilterCloseTrigger.on('click', function() {
    expo.cache.$mobileFilter.slideToggle(220);
    expo.cache.$mobileFilterClose.fadeToggle('fast');
    $('.filter-menu-container').removeClass('absolute mt-[-46px] z-10').slideToggle(220);
    //$('.main-content .container').removeClass('mt-[-18px]');
  });
};

expo.searchNav = function () {
  expo.cache.$mobileSearchTrigger.on('click', function() {
    expo.cache.$mobileSearch.slideToggle(220);
    expo.cache.$mobilePageOverlay.fadeToggle('fast');
  });
};

expo.mobileScrollHandler = function () {
  window.addEventListener('scroll', function() {
    if (window.scrollY > 0) {
      expo.cache.$mobilePageOverlay.css('top', '0');
      expo.cache.$mobilePageOverlay.css('height', '100dvh');
    } else {
      expo.cache.$mobilePageOverlay.css('top', '103px');
      expo.cache.$mobilePageOverlay.css('height', 'calc(100dvh - 103px)');
    }
  });
};

expo.equalHeights = function () {
  expo.cache.$w.on('load', resizeElements());

  expo.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );

  function resizeElements() {
    expo.cache.$productGridImages.css('height', 'auto').equalHeights();
    expo.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};

expo.sidebarViewMore = function () {
  if (!expo.cache.$sidebarViewMore.length) {
    return;
  }

  expo.cache.$sidebarViewMore.on('click', function() {
    $(this).prev('.sidebar-module__list').toggleClass('sidebar-module__list--expand');
  });
};

expo.sidebarDropdowns = function () {
  if (!expo.cache.$sidebarDropdown.length) {
    return;
  }

  
};

expo.sidebarDropdownCheck = function () {
  if (!expo.cache.$sidebarSubLists.length) {
    return;
  }

  expo.cache.$sidebarSubLists.each(function() {
    var $el = $(this);
    if ($el.find('.is-active').length) {
      $el.parent('.sidebar-sublist').addClass('is-open');
    }
  });

};



expo.cartPage = function () {
  
    return;
  

  expo.cache.$body.on('click', expo.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(expo.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

expo.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';

  // Open sub navs on small screens
  expo.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};

// Initialize expo's JS on docready
$(expo.init)